
import { buildOgLocaleMeta } from '@/utils/seo'

import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      paymentMethods: [],
      breadcrumb_list: [
        {
          text: this.$t('pages.paiementSecurise.breadcrumbHome'),
          to: { name: 'index' },
        },
        {
          text: this.$t('pages.paiementSecurise.breadcrumbPaiementSecurise'),
          to: { name: 'paiement-securise' },
        },
      ],
    }
  },
  async fetch() {
    await this.$paymentMethodService
      .fetch({
        include: 'image',
        sort: 'position',
        limit: this.$itemsRequestLimit,
      })
      .then(({ data }) => {
        this.paymentMethods = data.filter(payment => payment.is_active)
      })
      .catch(error => {
        this.$swalErrorMessage(error)
      })
  },
  head() {
    return {
      title: this.$t('pages.paiementSecurise.metaTitle'),
      link: [
        {
          rel: 'canonical',
          hid: 'canonical',
          href:
            this.$config.url +
            this.localePath({
              name: 'paiement-securise',
            }),
        },
      ],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('pages.paiementSecurise.metaDescription'),
        },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.$config.url + this.$route.path,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('pages.paiementSecurise.metaTitle'),
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('pages.paiementSecurise.metaDescription'),
        },
        { hid: 'og:site_name', property: 'og:site_name', content: 'Agmvision' },
        ...buildOgLocaleMeta(this.$i18n.locale),
        {
          hid: 'og:image',
          property: 'og:image',
          content: `${this.$config.url}/logo_og.png`,
        },
        { hid: 'twitter:card', name: 'twitter:card', content: 'summary' },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: this.$t('pages.paiementSecurise.metaTitle'),
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.$t('pages.paiementSecurise.metaDescription'),
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: `${this.$config.url}/logo_og.png`,
        },
      ],
    }
  },
  computed: {
    reassurances() {
      return [
        {
          icon: 'lock-alt',
          title: this.$t('pages.paiementSecurise.reassuranceSslTitle'),
          text: this.$t('pages.paiementSecurise.reassuranceSslText'),
        },
        {
          icon: 'credit-card-front',
          title: this.$t('pages.paiementSecurise.reassurance3dsTitle'),
          text: this.$t('pages.paiementSecurise.reassurance3dsText'),
        },
        {
          icon: 'check-circle',
          title: this.$t('pages.paiementSecurise.reassuranceNoStorageTitle'),
          text: this.$t('pages.paiementSecurise.reassuranceNoStorageText'),
        },
      ]
    },
  },
}
